module.exports = __webpack_public_path__ + "e92b0ba50c636718f77378093250e48f.svg";